var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getSelectedComponent)?_c(_vm.getSelectedComponent,{tag:"component"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }